// Auto-generated by scripts/updateVersion.js
export default '16.4.2';
